import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "CheckSolid",
  [
    [
      "path",
      {
        d: "M20.559 4.941c0.586 0.586 0.586 1.537 0.0 2.123l-12.0 12.0c-0.586 0.586-1.537 0.586-2.123 0.0l-6.0-6.0c-0.586-0.586-0.586-1.537 0.0-2.123s1.537-0.586 2.123 0.0L7.5 15.877 18.441 4.941c0.586-0.586 1.537-0.586 2.123 0.0z",
      },
    ],
  ],
  "currentColor"
);
